import React, { useState, useEffect, useRef } from "react";
import BackgroundImg from "../img/BackgroundNetImg.svg";
import HeaderAddApp from "./HeaderAddApp";
import Expand_left_light from "../img/Expand_left_light.svg";
import Expand_right_light from "../img/Expand_right_light.svg";
import info_light from "../img/info_light.svg";
import Tick from "../img/tick.svg";
import Add_round from "../img/Add_round.svg";
import Minus from "../img/Minus.svg";
import ArrowBottom from "../img/ArrowBottom.svg";
import api from "../../api/axiosInstance";
import { useLocation, useNavigate } from "react-router-dom";
import { div, span } from "motion/react-client";
import CustomLoader from "./CustomLoader";
import { motion, AnimatePresence } from "framer-motion";

// Dummy data for plans (replace with actual backend data as required)

const ProductPricing = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { id, project_type } = location.state || {};
  const [activePlan, setActivePlan] = useState("yearly");
  const [openTopupForPlan, setOpenTopupForPlan] = useState(null);
  const [selectedTopups, setSelectedTopups] = useState({});
  const [addonCartLoading, setAddonCartLoading] = useState(false);
  const [transitionLoading, setTransitionLoading] = useState(false);
  const [transition, setTransition] = useState(true);
  const [loading, setLoading] = useState(true);
  const [licenseData, setLicenseData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [cartLoadingPlanId, setCartLoadingPlanId] = useState(null);
  const [applicationName, setApplicationName] = useState("");
  const toggleRefs = useRef({});
  const topupRefs = useRef({});
  const topupRef = useRef(null);
  const [lastClickedTopupButton, setLastClickedTopupButton] = useState(null);
  const [addonData, setAddonData] = useState([]);
  const [selectedAddon, setSelectedAddon] = useState(null);

  const containersPerPage = screenWidth <= 640 ? 1 : 4;
  const totalPages = Math.ceil(licenseData.length / containersPerPage);
  const startIndex = currentPage * containersPerPage;
  const endIndex = startIndex + containersPerPage;
  const plansToDisplayPage = licenseData.slice(startIndex, endIndex);

  // Dummy function for toggling plans (monthly/yearly)
  const handlePlanToggle = (planType) => {
    setActivePlan(planType);
  };
  useEffect(() => {
    const filterType = activePlan === "monthly" ? "Month" : "Year";
    fetchLicensePlans(filterType);
  }, [activePlan]);

  const prevPage = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1); // Go to the previous page
    }
  };

  const nextPage = () => {
    if (currentPage < totalPages - 1) {
      setCurrentPage(currentPage + 1); // Go to the next page
    }
  };

  const fetchLicensePlans = async (filterType) => {
    const user_id = localStorage.getItem("user_id");
    setLoading(true);
    try {
      const response = await api.post(
        "/display/api/v1/display-license-details",
        {
          project_id: id,
          filter_type: filterType,
          user_id: user_id,
        }
      );

      if (response.data?.status === "success") {
        setLicenseData(response.data.data);

        setTimeout(() => {
          setTransition(false);
        }, 100);
      }
    } catch (error) {
      console.error("Failed to fetch license plans:", error);
    } finally {
      setLoading(false);
    }
  };

  const toggleTopupDropdown = (planId) => {
    // if we previously closed with outside click, reset
    if (lastClickedTopupButton === planId && openTopupForPlan === null) {
      // keep it closed
      setLastClickedTopupButton(null);
    } else {
      // normal toggle
      setOpenTopupForPlan((prev) => (prev === planId ? null : planId));
      setLastClickedTopupButton(planId);
    }
  };

  const fetchAddons = async () => {
    try {
      const token = localStorage.getItem("accessToken");
      const res = await api.get(
        `/admin-app/api/v1/list-addon-by-project/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (res.data.status === "success") {
        const addonDetails = res.data.data?.addon_details || [];
        setApplicationName(res.data.data?.name || "");

        // Transform API response to your UI structure
        const transformedAddons = addonDetails.map((addon) => ({
          id: addon.id,
          price: addon.durations[0]?.price || 0,
          duration:
            addon.durations[0]?.duration_name || "Duration not available",
          feature_details: {
            name: addon.name,
            description: addon.description,
            image: addon.image, // fallback
          },
          conditions: addon.addon_features.map((f) => f.statement),
        }));

        setAddonData(transformedAddons);
      }
    } catch (error) {
      console.error("Failed to fetch add-ons:", error);
    }
  };

  useEffect(() => {
    const filterType = activePlan === "monthly" ? "Month" : "Year";
    fetchLicensePlans(filterType);
    if (id) {
      fetchAddons(); // 👈 fetch addons when `id` is present
    }
  }, [activePlan, id]);

  const handleEdit = (licenseId) => {
    navigate(`/EditLicense`, {
      state: {
        licenseId: licenseId, // or just `licenseId` (shorthand property)
      },
    });
  };

  if (loading) {
    return <CustomLoader></CustomLoader>;
  }

  return (
    <div>
      <HeaderAddApp></HeaderAddApp>
      <div
        className="fixed bg-white bg-cover bg-center w-full max-h-[calc(100vh-64px)]"
        style={{
          backgroundImage: `url(${BackgroundImg})`,
          backgroundPosition: "50% 0%",
        }}
      >
        <div className="flex flex-col p-14 overflow-y-auto h-screen scrollbar-hide">
          {/* Heading with Buttons Row */}
          <div className="flex justify-between items-start">
            <div className="flex flex-col">
              <h1 className="text-3xl font-extrabold font-inter text-secondary">
                We want your retail business to grow and thrive
              </h1>

              <p className="blacktext text-lg mt-1">
                That’s why our pricing is flexible, affordable, and tailored to
                support businesses at every stage.
              </p>
            </div>

            <div className="flex gap-2">
              <button
                className="px-6 py-2 font-semibold text-sm text-white bg-primary rounded-md
                hover:scale-105 transition-transform duration-300"
                style={{ willChange: "transform" }}
                onClick={() => {
                  navigate("/addApplication", {
                    state: { activeTab: "CreateLicense" },
                  });
                }}
              >
                Add Plan Details
              </button>

              <button
                className="px-6 py-2 font-semibold text-sm text-white bg-primary rounded-md hover:scale-105 transition-transform duration-300"
                style={{ willChange: "transform" }}
                onClick={() => {
                  navigate("/addApplication", {
                    state: { activeTab: "CreateAddOn" },
                  });
                }}
              >
                Add Add-On
              </button>
            </div>
          </div>

          {/* Plan Toggle */}
          <div className="relative mt-8">
            <div
              className="absolute rounded-full px-3 py-1.5 font-semibold text-xs flex items-center gap-3 transform -translate-x-1/2 -translate-y-1/2 left-1/2"
              style={{
                background: "linear-gradient(270deg, #9061DB 0%, #8777F3 100%)",
              }}
            >
              <span
                onClick={() => handlePlanToggle("monthly")}
                className={`flex justify-center py-1.5 w-20 rounded-full text-sm font-bold cursor-pointer ${
                  activePlan === "monthly"
                    ? "bg-white text-[#9367D7]"
                    : "text-white"
                }`}
              >
                Monthly
              </span>
              <span
                onClick={() => handlePlanToggle("yearly")}
                className={`flex justify-center py-1.5 w-20 rounded-full text-sm font-bold cursor-pointer ${
                  activePlan === "yearly"
                    ? "bg-white text-[#9367D7]"
                    : "text-white"
                }`}
              >
                Yearly
              </span>
            </div>
          </div>

          <div
            className=" flex flex-col justify-around rounded-2xl mb-8"
            style={{ backgroundColor: "#E6E2FF" }}
          >
            {transitionLoading ? (
              <div className="flex justify-center items-center h-[500px]">
                <div className="w-12 h-12 border-4 border-[#9367D7] border-t-transparent rounded-full animate-spin"></div>
              </div>
            ) : (
              <>
                {activePlan === "monthly" && (
                  <div className="flex flex-col sm:flex-row justify-around py-10">
                    {/* <div className="flex gap-2 py-10  flex-wrap justify-center"> */}
                    {loading ? (
                      <p className="text-white text-center">Loading plans...</p>
                    ) : licenseData.length === 0 ? (
                      <div>
                        <span>No plan added yet.</span>
                      </div>
                    ) : (
                      plansToDisplayPage.map((plan, index) => (
                        <div
                          key={index}
                          className={`w-full sm:w-64 mt-4 flex flex-col justify-between min-h-[380px] items-center py-5 rounded-2xl mx-2 ${
                            plan.license_details.name === "Premium"
                              ? "text-white bg-[#4C3A68]"
                              : "bg-white"
                          }`}
                        >
                          <h1 className="text-sm font-bold">
                            {plan.license_details.name}
                          </h1>
                          {plan.discount_details?.have_discount ? (
                            <>
                              <span className="text-gray-400 line-through text-lg font-bold font-inter">
                                ₹ {plan.price}
                              </span>
                              <span className="font-bold text-2xl">
                                ₹ {plan.discount_details.updated_price}
                              </span>
                            </>
                          ) : (
                            <span className="font-bold text-2xl">
                              ₹ {plan.price}
                            </span>
                          )}

                          <span className="text-xs">{plan.duration}</span>

                          {/* {plan.is_carted ? (
                              <span
                                className="px-4 py-2 text-sm font-bold rounded-full mt-2"
                                style={{
                                  backgroundColor: "#D4C6FF",
                                  color: "gray",
                                  cursor: "default",
                                  border: "1px solid gray",
                                }}
                              >
                                Added to cart
                              </span>
                            ) : (
                              <span
                                className="px-6 py-2 text-sm font-bold cursor-pointer mt-2"
                                style={{
                                  color:
                                    plan.license_details.name === "Premium"
                                      ? "white"
                                      : "#9367D7",
                                  background:
                                    plan.license_details.name === "Premium"
                                      ? "linear-gradient(90deg, #9367D7 0%, #8777F3 100%)"
                                      : "transparent",
                                  border: "1px solid #9367D7",
                                  borderRadius: "20px",
                                  opacity:
                                    cartLoadingPlanId ===
                                    plan.license_details.license_id
                                      ? 0.6
                                      : 1,
                                  pointerEvents:
                                    cartLoadingPlanId ===
                                    plan.license_details.license_id
                                      ? "none"
                                      : "auto",
                                }}
                                // onClick={() => handleAddToCart(plan)}
                              >
                                {cartLoadingPlanId ===
                                plan.license_details.license_id
                                  ? "Adding..."
                                  : "Edit plan"}
                              </span>
                            )} */}

                          <span
                            className="px-6 py-2 text-sm font-bold cursor-pointer mt-2"
                            style={{
                              color:
                                plan.license_details.name === "Premium"
                                  ? "white"
                                  : "#9367D7",
                              background:
                                plan.license_details.name === "Premium"
                                  ? "linear-gradient(90deg, #9367D7 0%, #8777F3 100%)"
                                  : "transparent",
                              border: "1px solid #9367D7",
                              borderRadius: "20px",
                              opacity:
                                cartLoadingPlanId ===
                                plan.license_details.license_id
                                  ? 0.6
                                  : 1,
                              pointerEvents:
                                cartLoadingPlanId ===
                                plan.license_details.license_id
                                  ? "none"
                                  : "auto",
                            }}
                            // onClick={() => handleAddToCart(plan)}
                          >
                            {cartLoadingPlanId ===
                            plan.license_details.license_id
                              ? "Adding..."
                              : "Edit plan"}
                          </span>

                          <span className="font-medium text-xs px-6 text-center my-2 ">
                            {plan.license_details.description}
                          </span>

                          {plan.conditions.length > 0 && (
                            <>
                              <div class="flex flex-col">
                                <h1 className="w-64 px-5 font-semibold">
                                  Features :
                                </h1>
                                {plan.conditions.map((cond, i) => (
                                  <span
                                    key={i}
                                    className="flex text-xs mt-2 gap-4 w-64 px-5"
                                  >
                                    <img src={Tick} alt="" />
                                    <span>{cond}</span>
                                  </span>
                                ))}
                              </div>
                            </>
                          )}

                          <div className="relative w-full flex justify-center  mt-5">
                            <div
                              onClick={() =>
                                toggleTopupDropdown(
                                  plan.license_details.license_id
                                )
                              }
                              className="flex  w-[90%] px-2 py-1 justify-around text-sm font-bold rounded-full cursor-pointer"
                              style={{
                                color: "#9367D7",
                                border: "1px solid #9367D7",
                              }}
                            >
                              <span>Top up plan</span>
                              <img src={ArrowBottom} alt="" />
                            </div>

                            {/* Dropdown Menu */}
                            {openTopupForPlan ===
                              plan.license_details.license_id && (
                              <div
                                ref={topupRef}
                                className="absolute z-10 mt-2 w-full bg-white border rounded-b-2xl shadow flex flex-col items-center"
                              >
                                {plan.top_ups && plan.top_ups.length > 0 ? (
                                  <>
                                    {plan.top_ups.map((topup) => (
                                      <div
                                        key={topup.top_up_id}
                                        className="flex justify-between items-center mt-2 mb-2 px-2 py-2 text-sm hover:bg-gray-100 rounded-xl w-[90%]"
                                        style={{
                                          border: "1px solid #9367D7",
                                        }}
                                      >
                                        <div className="flex flex-col gap-1">
                                          <span className="text-[#ACA7A7] text-xs">
                                            {topup.name}
                                          </span>
                                          <span className="text-[#ACA7A7] text-xs">
                                            ₹{topup.price}/qty
                                          </span>
                                        </div>
                                        <div className="flex gap-1 items-center">
                                          <img
                                            src={Minus}
                                            alt="Decrease"
                                            className="cursor-pointer w-[20px]"
                                            onClick={() => {
                                              setSelectedTopups((prev) => {
                                                const currentQty =
                                                  prev[topup.top_up_id]
                                                    ?.quantity || 0;
                                                const newQty = Math.max(
                                                  0,
                                                  currentQty - 1
                                                );
                                                return {
                                                  ...prev,
                                                  [topup.top_up_id]: {
                                                    topup_id: topup.top_up_id,
                                                    quantity: newQty,
                                                    price: topup.price,
                                                  },
                                                };
                                              });
                                            }}
                                          />
                                          <input
                                            type="number"
                                            min={0}
                                            value={
                                              selectedTopups[topup.top_up_id]
                                                ?.quantity || 0
                                            }
                                            onChange={(e) => {
                                              const quantity = Math.max(
                                                0,
                                                parseInt(e.target.value, 10) ||
                                                  0
                                              );
                                              setSelectedTopups((prev) => ({
                                                ...prev,
                                                [topup.top_up_id]: {
                                                  topup_id: topup.top_up_id,
                                                  quantity,
                                                  price: topup.price,
                                                },
                                              }));
                                            }}
                                            className="bg-[#E6E2FF] h-6 w-12 rounded-lg text-center"
                                            style={{
                                              MozAppearance: "textfield", // Firefox
                                              WebkitAppearance: "none", // Safari and Chrome
                                              margin: 0,
                                            }}
                                          />
                                          <img
                                            src={Add_round}
                                            alt="Increase"
                                            className="cursor-pointer w-[20px]"
                                            onClick={() => {
                                              setSelectedTopups((prev) => {
                                                const currentQty =
                                                  prev[topup.top_up_id]
                                                    ?.quantity || 0;
                                                const newQty = currentQty + 1;
                                                return {
                                                  ...prev,
                                                  [topup.top_up_id]: {
                                                    topup_id: topup.top_up_id,
                                                    quantity: newQty,
                                                    price: topup.price,
                                                  },
                                                };
                                              });
                                            }}
                                          />
                                        </div>
                                      </div>
                                    ))}

                                    {/* Add this total pay div here for monthly plan too */}
                                    <div className="w-[90%] border-t border-gray-300 py-2 flex justify-between items-center">
                                      <p className="text-xs sm:text-sm font-semibold text-black font-inter">
                                        Total Top-Up Payment
                                      </p>
                                      <p className="text-xs sm:text-sm font-semibold text-black font-inter">
                                        ₹
                                        {Object.values(selectedTopups).reduce(
                                          (sum, item) =>
                                            sum + item.quantity * item.price,
                                          0
                                        )}
                                      </p>
                                    </div>

                                    <div class=" mb-3 w-full flex">
                                      <button
                                        style={{
                                          background:
                                            "linear-gradient(270deg, #9061DB 0%, #8777F3 100%)",
                                        }}
                                        className=" mx-auto w-[90%] rounded-full p-1 font-bold text-white"
                                        // onClick={() =>
                                        //   handleAddTopupToCart(plan)
                                        // }
                                        disabled={addonCartLoading} // optionally disable when loading
                                      >
                                        {addonCartLoading
                                          ? "Adding..."
                                          : "Add Top-Up"}
                                      </button>
                                    </div>
                                  </>
                                ) : (
                                  <div className="px-4 py-2 text-sm text-gray-500">
                                    No top-ups available
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                      ))
                    )}
                    {/* </div> */}
                  </div>
                )}

                {activePlan === "yearly" && (
                  <div className="flex flex-col sm:flex-row justify-around py-10">
                    <div className="flex sm:flex-row justify-center items-center w-full">
                      {loading ? (
                        <div className="text-white text-center">
                          Loading plans...
                        </div>
                      ) : (
                        <div className="flex sm:flex-row justify-center  w-full">
                          <div className="flex justify-center items-center">
                            {licenseData.length > containersPerPage && (
                              <img
                                src={Expand_left_light}
                                alt="Previous"
                                onClick={prevPage}
                                className="cursor-pointer w-10 h-10"
                                style={{ opacity: currentPage === 0 ? 0.4 : 1 }}
                              />
                            )}
                          </div>

                          {licenseData.length === 0 ? (
                            <div>
                              <span>No plan added yet.</span>
                            </div>
                          ) : (
                            plansToDisplayPage.map((plan, index) => (
                              <div
                                key={index}
                                className={`w-full sm:w-64 mt-4 flex flex-col justify-between min-h-[380px] items-center py-5 rounded-2xl mx-2 ${
                                  plan.license_details.name === "Premium"
                                    ? "text-white bg-[#4C3A68]"
                                    : "bg-white"
                                }`}
                              >
                                <div className="flex flex-col gap-2 justify-center items-center">
                                  <h1 className="text-lg font-bold">
                                    {plan.license_details.name}
                                  </h1>
                                  {plan.discount_details?.have_discount ? (
                                    <>
                                      <span className="text-gray-400 line-through text-lg font-bold font-inter">
                                        ₹ {plan.price}
                                      </span>
                                      <span className="font-bold text-2xl ">
                                        ₹ {plan.discount_details.updated_price}
                                      </span>
                                    </>
                                  ) : (
                                    <span className="font-bold text-2xl ">
                                      ₹ {plan.price}
                                    </span>
                                  )}

                                  {id === 1 && (
                                    <span className="mt-3 h-10 px-5 py-2 rounded-full bg-[#E6E2FF] text-sm font-semibold text-[#4C3A68] inline-flex items-center gap-2">
                                      Only {plan.unit_price}/Test
                                    </span>
                                  )}

                                  <span className="text-xs">
                                    {plan.duration}
                                  </span>
                                </div>

                                {/* {plan.is_carted ? (
                                <span
                                  className="px-4 py-2 text-sm font-bold rounded-full mt-2"
                                  style={{
                                    color: "gray",
                                    cursor: "default",
                                    border: "1px solid gray",
                                  }}
                                >
                                  Added to Cart
                                </span>
                              ) : (
                                <span
                                  className="px-6 py-2 text-sm font-bold cursor-pointer mt-2"
                                  style={{
                                    color:
                                      plan.license_details.name === "Premium"
                                        ? "white"
                                        : "#9367D7",
                                    background:
                                      plan.license_details.name === "Premium"
                                        ? "linear-gradient(90deg, #9367D7 0%, #8777F3 100%)"
                                        : "transparent",
                                    border: "1px solid #9367D7",
                                    borderRadius: "20px",
                                    opacity:
                                      cartLoadingPlanId ===
                                      plan.license_details.license_id
                                        ? 0.6
                                        : 1,
                                    pointerEvents:
                                      cartLoadingPlanId ===
                                      plan.license_details.license_id
                                        ? "none"
                                        : "auto",
                                  }}
                                  onClick={() =>
                                    handleEdit(plan.license_details.license_id)
                                  }
                                >
                                  {cartLoadingPlanId ===
                                  plan.license_details.license_id
                                    ? "Adding..."
                                    : "Edit plan"}
                                </span>
                              )} */}

                                <span
                                  className="px-6 py-2 text-sm font-bold cursor-pointer mt-2 hover:scale-105 transition-transform duration-300"
                                  style={{
                                    willChange: "transform",
                                    color:
                                      plan.license_details.name === "Premium"
                                        ? "white"
                                        : "#9367D7",
                                    background:
                                      plan.license_details.name === "Premium"
                                        ? "linear-gradient(90deg, #9367D7 0%, #8777F3 100%)"
                                        : "transparent",
                                    border: "1px solid #9367D7",
                                    borderRadius: "20px",
                                    opacity:
                                      cartLoadingPlanId ===
                                      plan.license_details.license_id
                                        ? 0.6
                                        : 1,
                                    pointerEvents:
                                      cartLoadingPlanId ===
                                      plan.license_details.license_id
                                        ? "none"
                                        : "auto",
                                  }}
                                  onClick={() =>
                                    handleEdit(plan.license_details.license_id)
                                  }
                                >
                                  {cartLoadingPlanId ===
                                  plan.license_details.license_id
                                    ? "Adding..."
                                    : "Edit plan"}
                                </span>

                                <span className="font-medium text-xs px-6 text-center my-2">
                                  {plan.license_details.description}
                                </span>

                                {plan.conditions.length > 0 && (
                                  <>
                                    <div class="flex flex-col ">
                                      <h1 className="w-64 px-5 font-semibold">
                                        Features :
                                      </h1>
                                      {plan.conditions.map((cond, i) => (
                                        <span
                                          key={i}
                                          className="flex text-xs mt-2 gap-4 w-64 px-5"
                                        >
                                          <img src={Tick} alt="" />
                                          <span>{cond}</span>
                                        </span>
                                      ))}
                                    </div>
                                  </>
                                )}

                                <div className="relative w-full flex justify-center  mt-5">
                                  <div
                                    onClick={() =>
                                      toggleTopupDropdown(
                                        plan.license_details.license_id
                                      )
                                    }
                                    className="flex w-[90%] px-4 py-1 justify-between text-sm font-bold rounded-full cursor-pointer"
                                    style={{
                                      color: "#9367D7",
                                      border: "1px solid #9367D7",
                                    }}
                                  >
                                    <span>Top-Up Plan</span>
                                    <img src={ArrowBottom} alt="" />
                                  </div>

                                  {/* Dropdown Menu */}
                                  {openTopupForPlan ===
                                    plan.license_details.license_id && (
                                    <div
                                      ref={topupRef}
                                      className="absolute z-10 mt-8 w-full bg-white rounded-b-2xl shadow flex flex-col items-center"
                                    >
                                      {plan.top_ups &&
                                      plan.top_ups.length > 0 ? (
                                        <>
                                          {plan.top_ups.map((topup) => (
                                            <div
                                              key={topup.top_up_id}
                                              className="flex justify-between items-center mt-2 mb-2 px-2 py-2 text-sm hover:bg-gray-100 rounded-xl w-[90%]"
                                              style={{
                                                border: "1px solid #9367D7",
                                              }}
                                            >
                                              <div className="flex flex-col gap-1">
                                                <span className="text-xs">
                                                  {topup.name}
                                                </span>
                                                <span className="text-[#ACA7A7] text-xs">
                                                  ₹{topup.price}
                                                  <span className="text-[#ACA7A7] text-xs">
                                                    /qty
                                                  </span>
                                                </span>
                                              </div>

                                              <div className="flex gap-1 items-center ">
                                                <img
                                                  src={Minus}
                                                  alt="Decrease"
                                                  className="cursor-pointer w-[20px]"
                                                  onClick={() => {
                                                    setSelectedTopups(
                                                      (prev) => {
                                                        const currentQty =
                                                          prev[topup.top_up_id]
                                                            ?.quantity || 0;
                                                        const newQty = Math.max(
                                                          0,
                                                          currentQty - 1
                                                        );
                                                        return {
                                                          ...prev,
                                                          [topup.top_up_id]: {
                                                            topup_id:
                                                              topup.top_up_id,
                                                            quantity: newQty,
                                                            price: topup.price,
                                                          },
                                                        };
                                                      }
                                                    );
                                                  }}
                                                />
                                                <input
                                                  type="number"
                                                  min={0}
                                                  value={
                                                    selectedTopups[
                                                      topup.top_up_id
                                                    ]?.quantity || 0
                                                  }
                                                  onChange={(e) => {
                                                    const quantity = Math.max(
                                                      0,
                                                      parseInt(
                                                        e.target.value,
                                                        10
                                                      ) || 0
                                                    );
                                                    setSelectedTopups(
                                                      (prev) => ({
                                                        ...prev,
                                                        [topup.top_up_id]: {
                                                          topup_id:
                                                            topup.top_up_id,
                                                          quantity,
                                                          price: topup.price,
                                                        },
                                                      })
                                                    );
                                                  }}
                                                  className="bg-[#E6E2FF] h-6 w-8 rounded-lg text-center"
                                                  style={{
                                                    MozAppearance: "textfield", // Firefox
                                                    WebkitAppearance: "none", // Safari and Chrome
                                                    margin: 0,
                                                  }}
                                                />
                                                <img
                                                  src={Add_round}
                                                  alt="Increase"
                                                  className="cursor-pointer w-[20px]"
                                                  onClick={() => {
                                                    setSelectedTopups(
                                                      (prev) => {
                                                        const currentQty =
                                                          prev[topup.top_up_id]
                                                            ?.quantity || 0;
                                                        const newQty =
                                                          currentQty + 1;
                                                        return {
                                                          ...prev,
                                                          [topup.top_up_id]: {
                                                            topup_id:
                                                              topup.top_up_id,
                                                            quantity: newQty,
                                                            price: topup.price,
                                                          },
                                                        };
                                                      }
                                                    );
                                                  }}
                                                />
                                              </div>
                                            </div>
                                          ))}

                                          {/* Dynamic total pay */}
                                          <div className="w-[90%] border-t border-gray-300 py-2 flex justify-between items-center">
                                            <p className="text-xs sm:text-sm font-semibold text-black font-inter">
                                              Total Top-Up Payment
                                            </p>
                                            <p className="text-xs sm:text-sm font-semibold text-black font-inter">
                                              ₹
                                              {Object.values(
                                                selectedTopups
                                              ).reduce(
                                                (sum, item) =>
                                                  sum +
                                                  item.quantity * item.price,
                                                0
                                              )}
                                            </p>
                                          </div>

                                          <div class=" mb-3 w-full flex">
                                            <button
                                              style={{
                                                background:
                                                  "linear-gradient(270deg, #9061DB 0%, #8777F3 100%)",
                                              }}
                                              className=" mx-auto w-[90%] rounded-full p-1 font-bold text-white"
                                              // onClick={() =>
                                              //   handleAddTopupToCart(plan)
                                              // }
                                              disabled={addonCartLoading} // optionally disable when loading
                                            >
                                              {addonCartLoading
                                                ? "Adding..."
                                                : "Add Top-Up"}
                                            </button>
                                          </div>
                                        </>
                                      ) : (
                                        <div className="px-4 py-2 text-sm text-gray-500">
                                          No top-ups available
                                        </div>
                                      )}
                                    </div>
                                  )}
                                </div>
                              </div>
                            ))
                          )}

                          <div className="flex justify-center items-center">
                            {licenseData.length > containersPerPage && (
                              <img
                                className="cursor-pointer w-10 h-10"
                                src={Expand_right_light}
                                alt="Next"
                                onClick={nextPage}
                                style={{
                                  opacity:
                                    currentPage === totalPages - 1 ? 0.4 : 1,
                                }}
                              />
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </>
            )}
          </div>

          {addonData.length > 0 && (
            <div
              class=" flex flex-col justify-around rounded-2xl py-10 mb-8"
              style={{ backgroundColor: "#E6E2FF" }}
            >
              <div className="flex flex-col items-center">
                <span className="font-bold text-3xl">Add-ons</span>
                <span className="mt-2 text-center">
                  Get the maximum benefit out of Zakya by choosing the add-ons
                  that work for you.
                </span>

                <div
                  className="w-[90%] rounded-2xl mt-5 flex flex-col sm:flex-row gap-5 justify-between"
                  style={{ backgroundColor: "#FFFFFF" }}
                >
                  {/* Left: Add-on list */}
                  <div className="w-full sm:w-2/3 p-2 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                    {addonData.map((addon, index) => (
                      <div
                        key={index}
                        onClick={() => setSelectedAddon(addon)}
                        className="cursor-pointer h-[220px] px-6 py-6 flex flex-col items-center gap-3 border border-[#CDC5FF] rounded-lg shadow-md bg-white hover:shadow-lg transition duration-200"
                      >
                        <img
                          src={addon.feature_details.image}
                          alt={addon.feature_details.name}
                          className="w-16 h-16 object-contain rounded"
                        />
                        <span className="text-sm font-bold text-center">
                          {addon.feature_details.name}
                        </span>
                        <span className="font-bold text-2xl text-[#4C3A68]">
                          ₹{addon.price}
                        </span>
                        <span className="text-xs text-gray-600">
                          {addon.duration}
                        </span>
                      </div>
                    ))}
                  </div>

                  <div className="w-px bg-gray-300 mx-1 hidden sm:block"></div>

                  {/* Right: Selected Add-on Details */}
                  <div className=" sm:w-1/3 overflow-y-auto overflow-x-hidden h-[220px] sm:h-auto mx-2 mt-2 mb-2 p-5 border border-[#CDC5FF] rounded-lg bg-white flex flex-col">
                    <AnimatePresence mode="wait">
                      <motion.div
                        key={selectedAddon ? selectedAddon.id : "empty"}
                        className="w-full overflow-y-auto overflow-x-hidden h-[220px] sm:h-auto mr-2 mt-2 mb-2 p-5   bg-white flex flex-col"
                        initial={{ opacity: 0, x: 20 }}
                        animate={{ opacity: 1, x: 0 }}
                        exit={{ opacity: 0, x: -50 }}
                        transition={{ duration: 0.3 }}
                      >
                        {selectedAddon ? (
                          <>
                            <img
                              src={selectedAddon.feature_details.image}
                              alt={selectedAddon.feature_details.name}
                              className="w-20 h-20 object-contain"
                            />
                            <h1 className="text-sm font-semibold  mb-2">
                              {selectedAddon.feature_details.name}
                            </h1>
                            <p className="text-2xl font-semibold   mb-2">
                              ₹{selectedAddon.price}
                            </p>
                            <p className="text-xs text-gray-500 ">
                              {selectedAddon.feature_details.description ||
                                "No description provided."}
                            </p>

                            {selectedAddon.conditions.length > 0 && (
                              <div className="mt-4">
                                {selectedAddon.conditions.map((cond, idx) => (
                                  <div
                                    key={idx}
                                    className="flex text-sm gap-2 mt-1 border-b border-b-[#CDC5FF] pb-2"
                                  >
                                    <img src={Tick} alt="" className="" />
                                    <span>{cond}</span>
                                  </div>
                                ))}
                              </div>
                            )}
                            <div className="w-full flex justify-end">
                              <button
                                onClick={() =>
                                  navigate("/editaddondetails", {
                                    state: {
                                      addonId: selectedAddon.id,
                                      id,
                                    },
                                  })
                                }
                                className="text-white text-sm font-semibold rounded-md px-5 py-1.5 mt-4 hover:scale-105 transition-transform duration-300"
                                style={{
                                  background:
                                    "linear-gradient(90deg, #9367D7 0%, #8777F3 100%)",
                                  opacity: addonCartLoading ? 0.6 : 1,
                                  pointerEvents: addonCartLoading
                                    ? "none"
                                    : "auto",
                                  willChange: "transform",
                                }}
                              >
                                {addonCartLoading
                                  ? "Adding..."
                                  : "Edit Add - On Plan"}
                              </button>
                            </div>
                          </>
                        ) : (
                          <div className="p-5 rounded-lg bg-white flex items-center justify-center">
                            <p className="text-sm text-gray-500 text-center">
                              Click on an add-on to see details
                            </p>
                          </div>
                        )}
                      </motion.div>
                    </AnimatePresence>
                  </div>
                </div>
              </div>

              {/* <div className="flex justify-center mt-5 px-5 sm:px-0">
            <div className="flex justify-center w-full sm:w-[80%]">
              <div className="flex flex-col gap-5 sm:w-2/3 items-center sm:items-start">
                <span
                  className="text-2xl font-semibold"
                  style={{ color: "#4C3A68" }}
                >
                  Trusted by the most
                </span>
                <span className="font-bold text-3xl sm:text-4xl text-center sm:text-left">
                  All our plans come with top-tier support absolutely free.
                </span>
              </div>

              <img src={CallLog} alt="" className="w-24 sm:w-36 mt-4 sm:mt-0" />
            </div>
          </div> */}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductPricing;
